// React
import Chart from 'react-apexcharts';
import React, { useState, useEffect } from 'react';
import { APIClient } from '../../../../helpers/api_helper';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const DashboardProposalSituationsChart = ({ isShow, office }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const api = new APIClient();

  const series = data.data;
  const options = {
    labels: data.labels,
    chart: {
      type: 'donut',
    },
    legend: {
      position: 'bottom',
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: data.colors,
  };

  const ProposalSituationChart = () => {
    return (
      <Card className="card-height-100">
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">
            Situações das Propostas
          </h4>
        </CardHeader>

        <CardBody className="p-0">
          <Chart
            dir="ltr"
            options={options}
            series={series}
            type="donut"
            height={450}
            className="apex-charts"
          />
        </CardBody>
      </Card>
    );
  };

  const getProposalSituation = async (office) => {
    await api
      .get(`/overview/proposal-by-situation?office=${office}`)
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  };

  useEffect(() => {
    getProposalSituation(office);
  }, [office]);

  return loading ? (
    <Col xs={12} md={6} lg={6}>
      <Card>
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={515} />
            </div>
          </Row>
        </SkeletonTheme>
      </Card>
    </Col>
  ) : isShow ? (
    <Col xs={12} md={6} lg={6}>
      <ProposalSituationChart />
    </Col>
  ) : null;
};
